var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9799 17.9663C19.1581 18.0007 19.4959 18.0919 19.6839 18.0919C21.3008 18.0919 22.6116 16.7605 22.6116 15.1181C22.6116 13.4757 21.3008 12.1443 19.6839 12.1443L19.4862 12.1495M4.75371 12.1495C3.21781 12.241 2.0001 13.5351 2.0001 15.1181C2.0001 16.7605 3.31087 18.0919 4.92781 18.0919H5.39462M4.75371 12.1495L2 4.80195L7.1117 5.75243L10.3869 1L15.1377 4.39981L19.5049 1.80425L19.4862 12.1495M4.75371 12.1495C4.75371 13.2449 4.89413 15.4848 4.89413 15.4848C5.09624 19.6722 8.28738 22.5 12.1945 22.5C16.232 22.5 19.4813 19.4463 19.4813 15.0627L19.4862 12.1495M4.75371 12.1495L19.4908 9.6372",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUudIcon);
export default __webpack_public_path__ + "static/media/uud_icon.03e9841ebd2f24f0fbd8720754464cbd.svg";
export { ForwardRef as ReactComponent };